import "./index.css";
import React from "react";
import { render } from "react-dom";
import { App } from "./App";

// 1Dash External Tracking — captures form fills + page views natively (server-independent).
(function () {
  try {
    var TID = "tk_7f1b128d2e01432c9ae952634d15bf3c";
    if (!document.querySelector('script[data-tracking-id="' + TID + '"]')) {
      var s = document.createElement("script");
      s.src = "https://data.1dash.pro/js/external-tracking.js";
      s.setAttribute("data-tracking-id", TID);
      s.async = true;
      document.body.appendChild(s);
    }
  } catch (e) {}
})();

// TruConversion — heat maps, session recordings, form analytics (site 57019).
(function () {
  try {
    if (document.getElementById("ti-js")) return;
    (window as any)._tip = (window as any)._tip || [];
    var js = document.createElement("script");
    js.id = "ti-js";
    js.async = true;
    js.src = location.protocol + "//app.truconversion.com/ti-js/57019/ca724.js";
    var tjs = document.getElementsByTagName("script")[0];
    if (tjs && tjs.parentNode) {
      tjs.parentNode.insertBefore(js, tjs);
    } else {
      document.body.appendChild(js);
    }
  } catch (e) {}
})();

// ClickCease — click-fraud protection (domain key 336825ceb076fb07f426496c5dc6c665).
(function () {
  try {
    if (document.querySelector("script.ct_clicktrue")) return;
    var cc = document.createElement("script");
    cc.async = true;
    cc.src = "https://ob.brilliantlocco.com/i/336825ceb076fb07f426496c5dc6c665.js";
    cc.className = "ct_clicktrue";
    document.head.appendChild(cc);
  } catch (e) {}
})();
render(<App data-id="element-338" />, document.getElementById("root"));